export const BREAKPOINTS = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  '3xl': 1920
};

export const getCurrentBreakpoint = () => {
  const width = window.innerWidth;

  if (width >= BREAKPOINTS['3xl']) return '3xl';
  if (width >= BREAKPOINTS['2xl']) return '2xl';
  if (width >= BREAKPOINTS.xl) return 'xl';
  if (width >= BREAKPOINTS.lg) return 'lg';
  if (width >= BREAKPOINTS.md) return 'md';
  if (width >= BREAKPOINTS.sm) return 'sm';
  return 'xs';
};

export const getOptimalColumnCount = (maxColumns = 4) => {
  const breakpoint = getCurrentBreakpoint();

  switch (breakpoint) {
    case '3xl':
      return Math.min(maxColumns, 6);
    case '2xl':
      return Math.min(maxColumns, 5);
    case 'xl':
      return Math.min(maxColumns, 4);
    case 'lg':
      return Math.min(maxColumns, 4);
    case 'md':
      return Math.min(maxColumns, 3);
    case 'sm':
      return Math.min(maxColumns, 2);
    case 'xs':
    default:
      return 1;
  }
};

export const getResponsiveGridClasses = (maxColumns = 4) => {
  const cols = Math.min(maxColumns, 6);

  switch (cols) {
    case 1:
      return "grid-cols-1";
    case 2:
      return "grid-cols-1 xs:grid-cols-1 sm:grid-cols-2";
    case 3:
      return "grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
    case 4:
      return "grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4";
    case 5:
      return "grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5";
    case 6:
    default:
      return "grid-cols-1 xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6";
  }
};

export const getResponsiveMasonryBreakpoints = (maxColumns = 4) => {
  return {
    default: Math.min(maxColumns, 6),
    1920: Math.min(maxColumns, 6),
    1536: Math.min(maxColumns, 5),
    1280: Math.min(maxColumns, 4),
    1024: Math.min(maxColumns, 4),
    768: Math.min(maxColumns, 3),
    640: Math.min(maxColumns, 2),
    320: 1
  };
};

export const getResponsivePadding = () => {
  return "px-2 sm:px-4 md:px-6 lg:px-8";
};

export const getResponsiveMargin = () => {
  return "mx-2 sm:mx-4 md:mx-6 lg:mx-8";
};

export const getResponsiveTextSize = (baseSize = 'text-lg') => {
  const sizeMap = {
    'text-xs': 'text-xs sm:text-sm md:text-base',
    'text-sm': 'text-sm sm:text-base md:text-lg',
    'text-base': 'text-base sm:text-lg md:text-xl',
    'text-lg': 'text-lg sm:text-xl md:text-2xl',
    'text-xl': 'text-xl sm:text-2xl md:text-3xl',
    'text-2xl': 'text-2xl sm:text-3xl md:text-4xl'
  };

  return sizeMap[baseSize] || baseSize;
};

export const isMobile = () => {
  return window.innerWidth < BREAKPOINTS.md;
};

export const isTablet = () => {
  const width = window.innerWidth;
  return width >= BREAKPOINTS.md && width < BREAKPOINTS.lg;
};

export const isDesktop = () => {
  return window.innerWidth >= BREAKPOINTS.lg;
};
